<template>
  <div id="teacherProfile">
    <v-container fluid>
      <v-row>
        <v-col cols="12" order="3" order-sm="1" class="col-nopadding">
          <h2 class="section-title text-center">
            {{ $t("Please set appropriate appointment") }}
          </h2>
        </v-col>
        <v-col cols="12" sm="2" order="1" order-sm="2">
          <v-card class="mx-auto" max-width="100%">
            <v-card-text>
              <div class="details text-center">
                <img
                  :src="
                    teacherInfo.img != ''
                      ? teacherInfo.img
                      : teacherInfo.title == 'mr'
                      ? defaultAvaterMale
                      : defaultAvaterfeMale
                  "
                  class="thumbnial"
                  style="cursor: pointer"
                  alt
                />

                <p class="text-center teacher-name">
                  <span class="main-color">{{ teacherInfo.name }}</span>
                  <v-icon color="success">fiber_manual_record</v-icon>
                </p>

                <p class="rate-stars text-center" v-if="count >= 3">
                  <v-icon
                    :color="teacherInfo.rating >= 1 ? '#FDCD25' : '#bfbfbf'"
                    >star_rate</v-icon
                  >
                  <v-icon
                    :color="teacherInfo.rating >= 2 ? '#FDCD25' : '#bfbfbf'"
                    >star_rate</v-icon
                  >
                  <v-icon
                    :color="teacherInfo.rating >= 3 ? '#FDCD25' : '#bfbfbf'"
                    >star_rate</v-icon
                  >
                  <v-icon
                    :color="teacherInfo.rating >= 4 ? '#FDCD25' : '#bfbfbf'"
                    >star_rate</v-icon
                  >
                  <v-icon
                    :color="teacherInfo.rating >= 5 ? '#FDCD25' : '#bfbfbf'"
                    >star_rate</v-icon
                  >
                </p>
              </div>
              <div class="student-info">
                <div class="main-color display-flex">
                  <p>
                    <v-icon class="main-color">payment</v-icon>
                  </p>
                  <p>
                    {{ $t("Hour price start from") }}
                    {{ teacherInfo.hour_price }} {{ $t("currency") }}
                  </p>
                </div>
                <div class="main-color display-flex">
                  <p>
                    <v-icon class="main-color">book</v-icon>
                  </p>
                  <p>{{ teacherInfo.curriculum }}</p>
                </div>
                <div
                  class="main-color display-flex"
                  v-for="(grade, index) in teacherInfo.grades"
                  :key="index"
                >
                  <p>
                    <v-icon class="main-color">language</v-icon>
                  </p>
                  <p>
                    <span>{{ grade }}</span>
                  </p>
                </div>
                <div class="socials text-center">
                  <a
                    :href="teacherInfo.facebook"
                    target="_blank"
                    v-if="teacherInfo.facebook"
                  >
                    <i class="fab fa-facebook-square"></i>
                  </a>

                  <a
                    :href="teacherInfo.twitter"
                    target="_blank"
                    v-if="teacherInfo.twitter"
                  >
                    <i class="fab fa-twitter-square"></i>
                  </a>
                  <a
                    :href="teacherInfo.instagram"
                    target="_blank"
                    v-if="teacherInfo.instagram"
                  >
                    <i class="fab fa-instagram"></i>
                  </a>
                  <a
                    :href="teacherInfo.linkedIn"
                    target="_blank"
                    v-if="teacherInfo.linkedIn"
                  >
                    <i class="fab fa-linkedin"></i>
                  </a>
                </div>
              </div>
              <div class="text-center">
                <v-btn class="editbtn" to="/teacher/profilesettings?edit=true">
                  <v-icon class="second-color">edit</v-icon>
                  {{ $t("editInfo") }}
                </v-btn>
              </div>
            </v-card-text>
          </v-card>

          <div class="rateSection" v-if="count >= 3">
            <v-card class="mx-auto" max-width="100%">
              <v-card-text>
                <h3 class="main-color">
                  <strong>
                    {{ $t("studentEvaluation") }}
                  </strong>
                </h3>
                <div
                  class="rating"
                  v-for="(item, index) in ratingArray"
                  :key="index"
                >
                  <div class="item">
                    <p class="main-color">
                      {{ item.question }} ({{ item.count }})
                    </p>
                    <div class="rate">
                      <v-icon
                        :color="item.avg_rating >= 1 ? '#FDCD25' : '#bfbfbf'"
                        >star_rate</v-icon
                      >
                      <v-icon
                        :color="item.avg_rating >= 2 ? '#FDCD25' : '#bfbfbf'"
                        >star_rate</v-icon
                      >
                      <v-icon
                        :color="item.avg_rating >= 3 ? '#FDCD25' : '#bfbfbf'"
                        >star_rate</v-icon
                      >
                      <v-icon
                        :color="item.avg_rating >= 4 ? '#FDCD25' : '#bfbfbf'"
                        >star_rate</v-icon
                      >
                      <v-icon
                        :color="item.avg_rating >= 5 ? '#FDCD25' : '#bfbfbf'"
                        >star_rate</v-icon
                      >
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </div>
        </v-col>
        <v-col cols="12" sm="8" order="4" order-sm="3" class="col-nopadding">
          <v-row class="fill-height">
            <v-col>
              <div class="text-right mb-4">
                <v-btn class="primary-btn" @click="addEvent">{{
                  $t("addAppointment")
                }}</v-btn>
              </div>
              <CalendarComponent :events="events" v-on:resetData="getEvent" />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="2" order="2" order-sm="4">
          <v-card class="mx-auto" max-width="100%">
            <v-card-text>
              <h3 class="main-color text-center">
                {{ $t("subjects") }}
              </h3>
              <div
                class="subject"
                v-for="(subjectsArray, gradeName) in teacherInfo.subjects"
                :key="gradeName"
                style="margin-bottom:15px"
              >
                <h3 class="main-color">{{ gradeName }}</h3>
                <div v-for="(subject, index) in subjectsArray" :key="index">
                  <p class="main-color text-center subject-title  mt-4 mb-4">
                    {{ subject.name }}
                  </p>
                  <div class="second-color subj-price display-flex">
                    <p>
                      <v-icon class="second-color">payment</v-icon>
                    </p>
                    <p>
                      {{ subject.teacher_fees }} {{ $t("currency") }}
                      {{ $t("on hour") }}
                    </p>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
          <v-card
            class="mx-auto"
            max-width="100%"
            v-if="teacherInfo.teaching_experience"
          >
            <v-card-text>
              <h3 class="main-color text-center">
                {{ $t("teaching_experience") }}
              </h3>
              <p class="main-color subj-title">
                {{ teacherInfo.teaching_experience.slice(0, 100) }}
              </p>
              <v-btn
                class="green-border-btn"
                v-if="teacherInfo.teaching_experience.length > 100"
                @click="teachingDialog = true"
                >{{ $t("Watch More") }}</v-btn
              >
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- add event modal  -->
    <!-- dialog -->
    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <div
          class="close-btn"
          :class="locale == 'en' ? 'text-right' : 'text-left'"
        >
          <v-btn color text @click="closeDialog()">
            <v-icon class="main-color">close</v-icon>
          </v-btn>
        </div>
        <v-card-title class="headline main-color">{{
          $t("addNewAppointment")
        }}</v-card-title>

        <div>
          <v-container>
            <div v-if="scheduleMessage != ''" style="text-align: center">
              <p class="alert" style="color: red">{{ scheduleMessage }}</p>
            </div>
            <v-row>
              <v-col cols="12" sm="6">
                <v-menu
                  v-model="menu3"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <label for="date">{{ $t("theDate") }} *</label>
                    <v-text-field
                      v-model="event.date"
                      prepend-inner-icon="event"
                      :rules="[validationRules.required]"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      solo
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="event.date"
                    @input="menu3 = false"
                    :min="nowDate"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <label for="duration">{{ $t("repeatAppointment") }} *</label>

                <v-select
                  v-model="event.repeat_for"
                  :items="durations"
                  item-text="text"
                  item-value="num"
                  solo
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="event.start"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <label for="from">{{ $t("from") }} *</label>
                    <v-text-field
                      v-model="event.start"
                      prepend-inner-icon="access_time"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      solo
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="menu2"
                    v-model="event.start"
                    full-width
                    @click:minute="$refs.menu2.save(event.start)"
                  ></v-time-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6">
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="event.end"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <label for="to">{{ $t("to") }} *</label>
                    <v-text-field
                      v-model="event.end"
                      prepend-inner-icon="access_time"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      solo
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="menu1"
                    v-model="event.end"
                    full-width
                    @click:minute="$refs.menu1.save(event.end)"
                  ></v-time-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="modal-btn text-center">
            <v-btn class="primary-btn" text @click="saveEvent">{{
              $t("save")
            }}</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- watch more Dialog -->
    <v-dialog v-model="teachingDialog" max-width="600">
      <v-card>
        <div
          class="close-btn"
          :class="locale == 'en' ? 'text-right' : 'text-left'"
        >
          <v-btn color text @click="teachingDialog = false">
            <v-icon class="main-color">close</v-icon>
          </v-btn>
        </div>
        <v-card-title class="headline main-color">{{
          $t("teaching_experience")
        }}</v-card-title>

        <div>
          <v-container>
            <v-row>
              <v-col>
                <p class="text-center">{{ teacherInfo.teaching_experience }}</p>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-card>
    </v-dialog>

    <Snack ref="snack"></Snack>
  </div>
</template>

<script>
import { validationMixin } from "../../mixins/validationMixin";
import CalendarComponent from "../../components/CalendarComponent";
export default {
  name: "teacherProfile",
  mixins: [validationMixin],
  components: {
    CalendarComponent
  },
  data() {
    return {
      defaultImg: require("../../assets/images/women.png"),
      teachingDialog: false,
      /* from date input */
      menu2: false,
      /* to date Input */
      menu1: false,
      menu3: false,
      dialog: false,
      today: new Date().toISOString().substr(0, 10),

      scheduleMessage: "",
      events: [],
      event: {
        start: null,
        end: null,
        date: new Date().toISOString().substr(0, 10),
        repeat_for: null
      },

      durations: [
        { text: this.$i18n.t("Withoud Repeat"), num: null },
        { text: this.$i18n.t("One Week"), num: "1" },
        { text: this.$i18n.t("Two Weeks"), num: "2" },
        { text: this.$i18n.t("Three Weeks"), num: "3" },
        { text: this.$i18n.t("Four Weeks"), num: "4" },
        { text: this.$i18n.t("Five Weeks"), num: "5" },
        { text: this.$i18n.t("Six Weeks"), num: "6" },
        { text: this.$i18n.t("Seven Weeks"), num: "7" },
        { text: this.$i18n.t("Eight Weeks"), num: "8" },
        { text: this.$i18n.t("Nine  Weeks"), num: "9" },
        { text: this.$i18n.t("Ten Weeks"), num: "10" }
      ],
      teacherInfo: {
        name: "داليا",
        // general_rate: "",
        // reviewers_num: "",
        hour_price: "5",
        grades: [],
        curriculum: "لغة عربية",
        facebook: "",
        twitter: "",
        instagram: "",
        linkedIn: "",
        // rating: [{ name: "", rate: "" }],
        subjects: [{ name: "", teacher_fees: "", website_fees: "" }],
        teaching_experience: ""
      },
      nowDate: new Date(Date.now()).toISOString().slice(0, 10),
      count: 0,
      ratingArray: [],
      editDialog: true,
      teacherId: ""
    };
  },

  methods: {
    addEvent() {
      this.dialog = true;
    },
    saveEvent() {
      this.$http
        .post(this.getApiUrl + "/teacher/schedule/save", this.event, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            locale: this.locale
          }
        })
        .then(response => {
          if (response.data.status.error) {
            this.scheduleMessage = response.data.status.message;
          } else {
            this.$refs.snack.sendSuccessAlert("تم إضافة الموعد");
            this.getEvent();
            this.closeDialog();
          }
        });
    },
    getEvent() {
      this.$http
        .get(this.getApiUrl + "/teacher/schedule", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            locale: this.locale
          }
        })
        .then(response => {
          if (response.data.status.error == false) {
            this.events = response.data.data;
          }
        });
    },
    getTeacherInfo() {
      this.$http
        .get(this.getApiUrl + "/teacher/profile", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            locale: this.locale
          }
        })
        .then(response => {
          this.teacherInfo = response.data.data;
          this.teacherId = this.teacherInfo.id;
        });
    },

    closeDialog() {
      this.dialog = false;
      this.event = {
        start: null,
        end: null,
        date: new Date().toISOString().substr(0, 10),
        repeat_for: null
      };
      this.scheduleMessage = "";
    },

    getRating() {
      this.$http
        .get(this.getApiUrl + "/teacher/evaluation", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            locale: this.locale
          }
        })
        .then(response => {
          if (response.data.status.error == false) {
            // console.log(response);
            this.ratingObject = response.data.data;
            this.count = response.data.data.count;
            this.ratingArray = response.data.data.data;
          }
        });
    }
  },
  mounted() {
    this.getEvent();
    this.getTeacherInfo();

    this.getRating();
    if (window.location.protocol == "https:") {
      this.$socket.channel("ScheduleChanged").listen("ScheduleChanged", e => {
        console.log(e);
        if (parseInt(e.teacher_id) == parseInt(this.teacherId)) {
          this.getEvent();
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/_variables.scss";
@import "../../assets/styles/_responsive.scss";

.details {
  p {
    margin-bottom: 0;
  }
}

.subject-title {
  margin-bottom: 0;
  margin-top: 10px;
}

.student-info {
  margin-right: 0 !important;
  margin-top: 1rem;
  .socials {
    margin-top: 1rem;

    svg {
      font-size: 2rem !important;
      padding: 0 5px;
    }
  }
  p {
    margin-bottom: 0;
    font-size: 0.8rem !important;
  }
}

.editbtn {
  background-color: transparent;
  border: 1px solid $second-color;
  color: $second-color;
  margin-top: 2rem;
}

.rateSection {
  margin-top: 1rem !important;
  .rating {
    margin-top: $margin-top;
    margin-bottom: $margin-bottom;
    .item {
      margin-bottom: 5px;
      p {
        margin-bottom: 0;
      }
    }
  }
}

.chart {
  margin-top: 1rem;
}

.v-card {
  margin-top: 1rem !important;
}
</style>
